import React from 'react'
import Field from '../Common/Field'

export default class TextArea extends Field {
  renderInput() {
    const {
      formikField, isRequired,
      config: { name, placeholder, readOnly, disabled }
    } = this.props

    return (
      <textarea
        id={name}
        className={`field__input field__input--textarea `}
        type="text"
        placeholder={placeholder}
        aria-required={!!isRequired}
        readOnly={!!readOnly}
        disabled={!!disabled}
        {...formikField}
        onFocus={this.onFocus}
        onBlur={this.onBlur}
      >
        {formikField.value}
      </textarea>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/FormTemplates/Field/TextArea.js